import { Container } from '../../../odie';

import { PantherBlockProps } from '../../defs/block';
import { blockPositionView } from '../../util/blockTools';
import { FitWidthBlockSprite } from './FitWidthBlockSprite';

// constants
//-----------------------------------------------------------------------------
const manifest = {
  small: 'panther/block.panther.small.png',
  large: 'panther/block.panther.large.png',
};

/*
    panther block view
*/
export class PantherBlockView extends Container {
  // init
  //-------------------------------------------------------------------------
  constructor(props: PantherBlockProps) {
    // create base view
    super();
    this.addChild(
      new FitWidthBlockSprite(
        props.width === 2 ? manifest.large : manifest.small,
        props,
      ),
    );
    blockPositionView(this, props);
  }

  public static assets(props: PantherBlockProps): string[] {
    return [props.width === 2 ? manifest.large : manifest.small];
  }
}
